import type { ReactNode } from "react";
import clsx from "clsx";
import styles from "./BadgeRow.module.css";

export interface BadgeRowProps {
  children: ReactNode;
  /**
   * `"sm"` (default) is badge-to-badge spacing; `"md"` suits a row that
   * mixes a badge with a value beside it.
   */
  gap?: "sm" | "md";
  /** Extra classes — column widths and the like stay with the page. */
  className?: string;
  title?: string;
}

/**
 * A wrapping inline row of badges.
 *
 * Wrapping rather than truncating is the point: a warning that only fits on
 * a wide screen is a warning nobody on a phone ever sees.
 */
export function BadgeRow({ children, gap = "sm", className, title }: BadgeRowProps) {
  return (
    <span
      className={clsx(styles.row, gap === "md" && styles.gapMd, className)}
      title={title}
    >
      {children}
    </span>
  );
}
